<template>
  <div id="fusion-bar-chart">
    <fusioncharts style="width: 100%" :type="newVis.chartConfigs.type" :dataFormat="newVis.chartConfigs.dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" :width="newVis.chartConfigs.width" :height="height"> </fusioncharts>
    <!-- <apexchart
      ref="chart"
      v-if="series"
      type="bar"
      :options="chartOptions"
      :series="series"
      :height="height"
    ></apexchart> -->
  </div>
</template>
<script>
export default {
  props: {
    containerId: { type: String, default: "container-bar-id" },
    containerClass: { type: String, default: "chart-container" },
    vis: { type: Object, default: null },
    height: { type: String, default: "250" },
    choosenTab: { type: String, default: "Total" }
  },
  data() {
    return {
      newVis: this.vis,
      dataSource: this.vis.dataSourceTotal
    };
  },
  watch: {
    height() {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 1);
    },
    vis() {
      this.newVis = this.vis;
      this.dataSource = this.vis.dataSourceTotal;
    },
    choosenTab() {
      this.dataSource = this.vis.dataSourceTotal;
    }
  },
  methods: {}
};
</script>
<style scoped></style>
